import { getLookupList, sortLookupOptionsByLabel } from "../utils/apiUtils"
import { ENTITY_NAME_CAMPAIGN } from "./dbConstants";

export const getListOptions = async(input) => {
  console.log("CampaignDAO.getListOptions - input:", input);
  const companyId = input?.companyId || null;
  return sortLookupOptionsByLabel(await getLookupList(ENTITY_NAME_CAMPAIGN, { companyId }))
}